export const INVALIDATE_CAMPAIGN_PARAM = 'invalidateCampaign';
